// https://docs.sheetjs.com/docs/demos/frontend/react/
// https://www.npmjs.com/package/@react-pdf/renderer

//import axios from "axios";
import { utils, writeFile } from 'xlsx';
import { getNodes } from '@/utils/Table';

// to export the data
export const exportData = (type,api,table/*,params = {}*/) => {

    switch(type){

        case 'csv':
            exportToCSV(api/*,table,params*/);
            break;

        case 'excel':
            exportToExcel(api,table/*,params*/);
            break;

        case 'pdf':
            //exportToPDF(api,table,params);
            break;

        case 'print':
            window.print();
            break;
    }
}

/*
export const exportToPDF = (api,table,params = {}) => {
  
}
*/

export const exportToCSV = (api/*,table,params = {}*/) => {

    // if selected nodes, export only those ones
    var onlySelectedAllPages = false;
    var selectedNodes = api?.getSelectedNodes();
    if(selectedNodes && selectedNodes.length > 0){
        onlySelectedAllPages = true;
    }

    api?.exportDataAsCsv({onlySelectedAllPages:onlySelectedAllPages});
}

export const exportToExcel = async (api,table/*,params = {}*/) => {

    var data = [];

    // get only current visible rows with filters, sort, order, etc.

    // if selected nodes, export only those ones
    var nodes = [];
    var selectedNodes = api?.getSelectedNodes();
    if(selectedNodes && selectedNodes.length > 0){
        nodes = selectedNodes;
    }
    else{
        // all the nodes that are not filtered
        nodes = getNodes(api,false,true);
    }

    // change values for the 'valueFormatter' ones
    if(nodes && nodes.length > 0){

        // get columns states
        var columnsDefs = api.getColumnDefs();
        var columns = [];
        columnsDefs && columnsDefs.map((columnDef) => {

            // remove actions column
            if(columnDef?.colId !== 'actions'){

                // remove hidden columns
                if(!columnDef?.hide){
                            
                    columns.push({
                        id: columnDef?.colId,
                        name: columnDef?.headerName
                    });
                }
            }
        });
        
        nodes.map((node) => {

            //var nodeData =  node?.data;
            var row = {};
            
            columns?.map((column) => {

                var field = column?.id;
                var name = column?.name;
                
                var cellValue = api.getCellValue({ 
                    rowNode: node, 
                    colKey: field,
                    useFormatter: true,
                });

                row[name] = cellValue;
                
            });

            data.push(row);
        });
    }

    // generate worksheet from state
    const ws = utils.json_to_sheet(data);
  
    // create workbook and append worksheet
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws,table);
  
    // export to XLSX
    writeFile(wb,table+".xlsx");
}; 